import React from "react";
import { Button, Glyphicon, Row, Col } from "react-bootstrap";
import _ from "lodash";

import CurrencyActions from "../actions/CurrencyActions";

import CurrencyStore from "../stores/CurrencyStore";

import CurrencyDeleteModal from "./CurrencyDeleteModal";
import CurrencyEditModal from "./CurrencyEditModal";

export default class Currencies extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = Currencies.getStoreState();
		this.state.showCurrencyDeleteModal = false;
		this.state.showCurrencyEditModal = false;
		this.state.errors = null;

		this._onChange = this._onChange.bind(this);
		this.handleCurrencyDeleteModalClose = this.handleCurrencyDeleteModalClose.bind(this);
		this.handleCurrencyEditModalClose = this.handleCurrencyEditModalClose.bind(this);
		this.handleCurrencyDelete = this.handleCurrencyDelete.bind(this);
	}

	static getStoreState()
	{
		return {
			currencies: CurrencyStore.getCurrencies(),
			currencyDefinitions: CurrencyStore.getCurrencyDefinitions()
		};
	}

	handleCurrencyDeleteModalClose()
	{
		this.setState({
			deleteCurrencyId: null,
			showCurrencyDeleteModal: false
		});
	}

	handleCurrencyEditModalClose()
	{
		this.setState({
			editCurrencyId: null,
			showCurrencyEditModal: false
		});
	}

	handleCurrencyDeleteClicked(currencyId)
	{
		this.setState({
			deleteCurrencyId: currencyId,
			showCurrencyDeleteModal: true,
			errors: null
		});
	}

	handleCurrencyEditClicked(currencyId)
	{
		this.setState({
			editCurrencyId: currencyId,
			showCurrencyEditModal: true,
			errors: null
		});
	}

	async handleCurrencyDelete(currencyId)
	{
		try
		{
			await CurrencyActions.deleteCurrency(currencyId);
		}
		catch (result)
		{
			let errors = null;
			if (result && result.response && result.response.body) {
				errors = result.response.body;
			}
			this.setState({ errors });
		}
	}

	handleCurrencyAdd() {
		this.setState({
			showCurrencyEditModal: true,
			editCurrencyId: null,
			errors: null
		});
	}

	_onChange()
	{
		this.setState(Currencies.getStoreState());
	}

	componentDidMount()
	{
		CurrencyStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		CurrencyStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const { currencies, currencyDefinitions, errors } = this.state;
		const currencyToEdit = (this.state.editCurrencyId) ? _.cloneDeep(currencies.find(c => c.id === this.state.editCurrencyId)) : null;

		return (
			<Row>
				{this.state.showCurrencyEditModal &&
					<CurrencyEditModal
						onClose={this.handleCurrencyEditModalClose}
						onSave={CurrencyActions.saveCurrency}
						currency={currencyToEdit}
						currencyDefinitions={currencyDefinitions}
					/>
				}
				{this.state.showCurrencyDeleteModal &&
					<CurrencyDeleteModal
						onClose={this.handleCurrencyDeleteModalClose}
						onDelete={this.handleCurrencyDelete}
						currencyId={this.state.deleteCurrencyId}
					/>
				}
				<Col xs={10} xsOffset={1}>
					<Row>
						<Col xs={5}>
							<strong>Currency</strong>
						</Col>
						<Col xs={7} />
					</Row>
					{currencies.map(currency => {
						return (
							<Row key={currency.id} className="currency">
								<Col xs={5}>
									{currency.name} ({currency.symbol})
								</Col>
								<Col xs={7} className="currency-buttons">
									<Button
										bsSize={"sm"}
										bsStyle={"default"}
										onClick={this.handleCurrencyEditClicked.bind(this, currency.id)}
									>
										<Glyphicon glyph="pencil"/>
									</Button>
									<Button
										bsSize={"sm"}
										bsStyle={"danger"}
										onClick={this.handleCurrencyDeleteClicked.bind(this, currency.id)}
										disabled={currency.isInUse}
									>
										<Glyphicon glyph={"trash"}/>
									</Button>
								</Col>
							</Row>
						);
					})}
					{errors && _.keys(errors).map(fieldName => {
						let errorMessages = errors[fieldName];
						return (
							<p key={fieldName} className="text-danger">
								<span>{fieldName}: </span>
								{errorMessages.map((msg, msgIndex) => {
									return (
										<span key={msgIndex}>{msg}</span>
									);
								})}
							</p>
						);
					})}
					<Button
						bsSize={"sm"}
						bsStyle={"success"}
						onClick={this.handleCurrencyAdd.bind(this)}
					>
						<Glyphicon glyph={"plus"} />
					</Button>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Currencies.jsx